import { action, observable } from 'mobx';
import { setMap } from '../Utils/Array';
import { bind } from '../Utils/Bind';
import { HttpClient, IConfig } from './HttpClient';

export class PowerBIStore {
    public constructor(httpClient: HttpClient) {
        this.httpClient = httpClient;
    }

    @action
    public async loadPowerBiReportAsync(id: string, config?: IConfig) {
        const report = await this.httpClient.get<{ report: any; tokenData: any }>(
            `/api/v1/power-bi/reports/${id}`,
            config
        );

        if (report) this.reports.set(id, report);
    }

    @action
    public async loadPowerBiDashboardAsync(id: string, config?: IConfig) {
        const dashboard = await this.httpClient.get<{ dashboard: any; tokenData: any }>(
            `/api/v1/power-bi/dashboards/${id}`,
            config
        );

        if (dashboard) this.dashboards.set(id, dashboard);
    }

    @action
    public async loadPowerBiDashboardsAsync() {
        const dashboards = await this.httpClient.get<any[]>(`/api/v1/power-bi/dashboards`);

        setMap(this.dashboards, dashboards, d => d.id);
    }

    @action
    public async loadPowerBiReportsAsync() {
        const reports = await this.httpClient.get<any[]>(`/api/v1/power-bi/reports`);

        setMap(this.reports, reports, r => r.id);
    }

    @bind
    @action
    public async sendKeepAliveAsync() {
        await this.httpClient.get(`/api/v1/power-bi/provision`);
    }

    @observable
    public reports = new Map<string, any>();
    @observable
    public dashboards = new Map<string, any>();
    private readonly httpClient: HttpClient;
}
